import './styles/index.css';

import 'core-js/fn/array/from';
import 'core-js/fn/array/includes';
import 'core-js/fn/object/keys';
import 'core-js/fn/object/values';

// import Raven from 'raven-js';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import createStore from 'store';
import App from 'components/App';

import pkg from '../package.json';

console.log('Groeistad', pkg.version);

// if (process.env.REACT_APP_SENTRY_DSN) {
//   const dsn = process.env.REACT_APP_SENTRY_DSN;
//   Raven.config(dsn).install();
// }

ReactDOM.render(
  <Provider store={createStore()}>
    <App />
  </Provider>,
  document.getElementById('app-root')
);



// WEBPACK FOOTER //
// ./src/index.js